import { v4 as uuidv4 } from 'uuid';

// Same id format as DealerFactory: asst_<normalized name>_<16 chars of a uuid v4>.
export const generateAssistantId = (name) => {
  const formattedName = name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // Remove accents but keep base characters
    .replace(/\s+/g, '_') // Replace spaces with underscores
    .replace(/[^a-z0-9_]/g, ''); // Remove special characters except underscores
  return `asst_${formattedName}_${uuidv4().slice(0, 16)}`;
};
